import {
  faEnvelope, faPeopleArrows, faSmile, faTags, faStethoscope, faGraduationCap, faCubes, faIdBadge, faClock, faClinicMedical, faInfoCircle, faSchool,
  faCalendar, faUserGraduate, faCogs, faChartPie, faUsers
} from '@fortawesome/pro-solid-svg-icons'
import { isObject, recursiveIncludes } from '.'
import { InstitutionOptions, MACCS_ENVIRONMENT, NURSE_ENVIRONMENT, ROLE_ADMIN_HOSPITAL_RO, ROLE_ADMIN_RESEAU, ROLE_CLINICAL_SECRETARY, ROLE_INSTITUTION_GROUP_ADMIN, SupportedRoles } from './constants'
import { Routes } from '../routes'
import ExperimentalTitle from '../Components/shared/ExperimentalTitle'

const {
  COORDINATOR, ENCODER, HOSPITAL_ADMIN, INSTITUTION_GROUP_ADMIN, SUPERVISOR, VALIDATOR, DOMAIN_EVALUATOR
} = SupportedRoles

const {
  BADGES, CHANGELOG_MANAGEMENT, CONTACT_PERSONS, INSTITUTIONS, INSTITUTION_SECTORS, INTERNSHIPS, MAILS_LIST, PROFILE_PAGE, QUOTAS, SCHOOLS, SCHOOL_SECTION,
  SETTINGS, SHIFTS_MANAGER, STUDENTS, STUDENTS_EVALUATION, TAGS_MANAGEMENT, SPECIALITIES, ASSISTANTS
} = Routes

export const getAdminMenu = t => {
  return [
    {
      iconName: faClinicMedical,
      label: t('Internships institutions'),
      admin: false,
      route: INSTITUTIONS
    },
    {
      iconName: faSchool,
      label: t('Schools'),
      admin: false,
      route: SCHOOLS
    },
    {
      iconName: faEnvelope,
      label: t('Mails list'),
      admin: false,
      route: MAILS_LIST
    },
    {
      iconName: faTags,
      label: t('Tags management'),
      route: TAGS_MANAGEMENT
    },
    {
      iconName: faInfoCircle,
      label: t('Changelog management'),
      route: CHANGELOG_MANAGEMENT
    }
  ]
}

export const getSchoolMenu = (t, roles, betaMode) => {
  const menu = [
    {
      iconName: faCalendar,
      label: t('Internships'),
      admin: false,
      route: INTERNSHIPS,
      key: 'SCHOOL_INTERNSHIPS'
    },
    {
      iconName: faUserGraduate,
      label: t('My students'),
      admin: false,
      route: STUDENTS,
      key: 'SCHOOL_STUDENTS'
    }
  ]

  if (!recursiveIncludes(roles, [SUPERVISOR, DOMAIN_EVALUATOR])) {
    menu.push({
      iconName: faGraduationCap,
      label: t('Sections and school years'),
      admin: false,
      route: SCHOOL_SECTION
    })
  }

  if (!roles.includes(DOMAIN_EVALUATOR)) {
    menu.push({
      iconName: faClinicMedical,
      label: t('Internships institutions'),
      admin: false,
      route: INSTITUTIONS
    })
  }

  if (betaMode.active && roles.includes(ENCODER)) {
    menu.push({
      iconName: faChartPie,
      label: <ExperimentalTitle title='menus.school_places' />,
      admin: true,
      route: QUOTAS
    })
  }

  if (recursiveIncludes(roles, [ENCODER, COORDINATOR])) {
    menu.push({
      iconName: faPeopleArrows,
      label: t('common.contact_persons'),
      admin: false,
      route: CONTACT_PERSONS
    })
    menu.push({
      iconName: faCogs,
      label: t('Settings'),
      admin: true,
      route: SETTINGS
    })
  }

  if (!roles.includes(DOMAIN_EVALUATOR)) {
    menu.push(
      {
        iconName: faTags,
        label: t('Tags management'),
        route: TAGS_MANAGEMENT
      }
    )
  }

  return menu
}

export const getInstitutionMenu = (t, roles, institution, modules, linkRequests, environment = NURSE_ENVIRONMENT) => {
  if (roles.includes(VALIDATOR)) {
    return [
      {
        iconName: faCalendar,
        label: t('Internships'),
        admin: false,
        route: INTERNSHIPS,
        key: 'INSTITUTION_INTERNSHIPS'
      },
      {
        iconName: faClock,
        label: t('Shifts Validation'),
        admin: false,
        route: SHIFTS_MANAGER
      },
      {
        iconName: faStethoscope,
        label: t('Care units'),
        admin: false,
        route: INSTITUTION_SECTORS
      }
    ]
  }

  const isAdmin = recursiveIncludes(roles, [HOSPITAL_ADMIN, INSTITUTION_GROUP_ADMIN])
  const menu = [
    {
      iconName: faCalendar,
      label: t('Internships'),
      admin: false,
      route: INTERNSHIPS,
      key: 'INSTITUTION_INTERNSHIPS'
    }
  ]

  if (!roles.includes(INSTITUTION_GROUP_ADMIN)) {
    /** @TODO 2024-01-22 move this outside de condition when Students view will be developed */
    menu.push({
      iconName: faUserGraduate,
      label: t('Students'),
      admin: false,
      route: STUDENTS,
      key: 'INSTITUTION_STUDENTS'
    })
  }

  if (recursiveIncludes(roles, [HOSPITAL_ADMIN, INSTITUTION_GROUP_ADMIN]) && isObject(modules) && modules[InstitutionOptions.RECRUITMENT_MODULE]) {
    menu.push({
      iconName: faSmile,
      label: t('Student feedback'),
      admin: false,
      route: STUDENTS_EVALUATION
    })
  }

  if (environment !== MACCS_ENVIRONMENT || !roles.includes(ROLE_INSTITUTION_GROUP_ADMIN)) {
    menu.push({
      iconName: faClock,
      label: t('Shifts Manager'),
      admin: true,
      route: SHIFTS_MANAGER
    })
  }

  menu.push({
    iconName: faSchool,
    label: t('Schools'),
    admin: false,
    route: SCHOOLS,
    dot: !!linkRequests.length
  })

  if (roles.includes(ROLE_INSTITUTION_GROUP_ADMIN)) {
    menu.push({
      iconName: faClinicMedical,
      label: t('Institutions'),
      admin: true,
      route: INSTITUTIONS
    })
  }

  if (environment !== MACCS_ENVIRONMENT) {
    menu.push({
      iconName: faStethoscope,
      label: t('Care units'),
      admin: false,
      route: INSTITUTION_SECTORS
    })
  }

  /** @TODO 2024-01-22 Remove this condition when view is developed for INSTITUTION_GROUP_ADMIN users */
  if (!roles.includes(INSTITUTION_GROUP_ADMIN)) {
    menu.push({
      iconName: faPeopleArrows,
      label: t('common.contact_persons'),
      admin: false,
      route: CONTACT_PERSONS
    })
  }

  if (isAdmin) {
    /** @TODO 2024-01-22 Remove this condition when view is developed for INSTITUTION_GROUP_ADMIN users */
    if (!roles.includes(INSTITUTION_GROUP_ADMIN)) {
      menu.push({
        iconName: faChartPie,
        label: t('Quotas and places'),
        admin: true,
        route: QUOTAS
      })
    }

    menu.push({
      iconName: faUsers,
      label: t('Badges management'),
      admin: true,
      route: BADGES
    })

    if (isObject(modules) && modules[InstitutionOptions.MODULE_SETTINGS]) {
      menu.push({
        iconName: faCubes,
        label: t('Modules settings'),
        admin: false,
        route: Routes.MODULES_SETTINGS
      })
    }

    if (environment === MACCS_ENVIRONMENT || roles.includes(ROLE_INSTITUTION_GROUP_ADMIN)) {
      menu.push({
        iconName: faIdBadge,
        label: t('Profile'),
        admin: false,
        route: PROFILE_PAGE
      })
    }

    menu.push({
      iconName: faCogs,
      label: t('Settings'),
      admin: true,
      route: SETTINGS
    })
  }

  if (!roles.includes(INSTITUTION_GROUP_ADMIN)) {
    menu.push({
      iconName: faTags,
      label: t('Tags management'),
      route: TAGS_MANAGEMENT
    })
  }

  return menu
}

export const getSchoolMaccsMenu = (t, roles) => {
  const menu = [
    {
      iconName: faCalendar,
      label: t('Internships'),
      admin: false,
      route: INTERNSHIPS,
      key: 'SCHOOL_INTERNSHIPS'
    },
    {
      iconName: faClock,
      label: t('Shifts Manager'),
      admin: false,
      route: SHIFTS_MANAGER
    },
    {
      iconName: faUserGraduate,
      label: t('Assistants'),
      admin: false,
      route: ASSISTANTS,
      key: 'SCHOOL_STUDENTS'
    }
    // @TODO 2023-05-08: reactivate to have the attractivity module view into the menu
    // {
    //   iconName: faSmile,
    //   label: t('Assistants feedback'),
    //   admin: false,
    //   route: STUDENTS_EVALUATION
    // }
  ]

  if (roles.includes(ROLE_ADMIN_RESEAU) || roles.includes(ROLE_CLINICAL_SECRETARY)) {
    menu.push({
      iconName: faGraduationCap,
      label: t('Specialities and school years'),
      admin: false,
      route: SPECIALITIES
    })
    menu.push({
      iconName: faClinicMedical,
      label: t('Internships institutions'),
      admin: false,
      route: INSTITUTIONS
    })
    menu.push({
      iconName: faUsers,
      label: t('Reporting'),
      admin: true,
      route: BADGES
    })
  }

  menu.push({
    iconName: faIdBadge,
    label: t('Profile'),
    admin: false,
    route: PROFILE_PAGE
  })
  menu.push({
    iconName: faPeopleArrows,
    label: t('Contact persons'),
    admin: false,
    route: CONTACT_PERSONS
  })
  menu.push({
    iconName: faCogs,
    label: t('Settings'),
    admin: true,
    route: SETTINGS
  })

  return menu
}

export const getInstitutionMaccsMenu = (t, roles) => {
  if (roles.includes(ROLE_ADMIN_HOSPITAL_RO)) {
    return [
      {
        iconName: faCalendar,
        label: t('Internships'),
        admin: false,
        route: INTERNSHIPS,
        key: 'INSTITUTION_INTERNSHIPS'
      },
      {
        iconName: faClock,
        label: t('Shifts Manager'),
        admin: false,
        route: SHIFTS_MANAGER
      },
      {
        iconName: faUserGraduate,
        label: t('Assistants'),
        admin: false,
        route: ASSISTANTS,
        key: 'INSTITUTION_STUDENTS'
      },
      {
        iconName: faUsers,
        label: t('Reporting'),
        admin: true,
        route: BADGES
      },
      {
        iconName: faIdBadge,
        label: t('Profile'),
        admin: false,
        route: PROFILE_PAGE
      },
      {
        iconName: faCogs,
        label: t('Settings'),
        admin: true,
        route: SETTINGS
      }
    ]
  }

  return [
    {
      iconName: faCalendar,
      label: t('Internships'),
      admin: false,
      route: INTERNSHIPS,
      key: 'INSTITUTION_INTERNSHIPS'
    },
    {
      iconName: faClock,
      label: t('Shifts Manager'),
      admin: true,
      route: SHIFTS_MANAGER
    },
    {
      iconName: faUserGraduate,
      label: t('Assistants'),
      admin: false,
      route: ASSISTANTS,
      key: 'INSTITUTION_STUDENTS'
    },
    {
      iconName: faSchool,
      label: t('Schools'),
      admin: false,
      route: SCHOOLS
    },
    {
      iconName: faUsers,
      label: t('Reporting'),
      admin: true,
      route: BADGES
    },
    {
      iconName: faPeopleArrows,
      label: t('Contact persons'),
      admin: false,
      route: CONTACT_PERSONS
    },
    {
      iconName: faIdBadge,
      label: t('Profile'),
      admin: false,
      route: PROFILE_PAGE
    },
    {
      iconName: faCogs,
      label: t('Settings'),
      admin: true,
      route: SETTINGS
    }
  ]
}

export const getStudentMenu = t => {
  return [
    {
      iconName: faCalendar,
      label: t('My internships'),
      admin: false,
      route: INTERNSHIPS
    },
    {
      iconName: faIdBadge,
      label: t('My profile'),
      admin: false,
      route: PROFILE_PAGE
    }
  ]
}

export const getAssistantMenu = t => {
  return [
    {
      iconName: faCalendar,
      label: t('My internships'),
      admin: false,
      route: INTERNSHIPS
    },
    {
      iconName: faIdBadge,
      label: t('My profile'),
      admin: false,
      route: PROFILE_PAGE
    }
  ]
}

export const getObserversMenu = t => {
  return [
    {
      iconName: faCalendar,
      label: t('Internships'),
      admin: false,
      route: INTERNSHIPS,
      key: 'INSTITUTION_INTERNSHIPS'
    },
    {
      iconName: faClock,
      label: t('Shifts Manager'),
      admin: false,
      route: SHIFTS_MANAGER
    },
    {
      iconName: faUserGraduate,
      label: t('Students'),
      admin: false,
      route: STUDENTS,
      key: 'INSTITUTION_STUDENTS'
    },
    {
      iconName: faStethoscope,
      label: t('Care units'),
      admin: false,
      route: INSTITUTION_SECTORS
    },
    {
      iconName: faCogs,
      label: t('Settings'),
      admin: false,
      route: SETTINGS
    }
  ]
}
